import { supabase } from './supabase';

// VAPID Public Key – wird nach Edge Function Setup hier eingetragen
const VAPID_PUBLIC_KEY = import.meta.env.VITE_VAPID_PUBLIC_KEY || '';

function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map(char => char.charCodeAt(0)));
}

export const isPushSupported = (): boolean => {
  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
};

export const getPushPermission = (): NotificationPermission => {
  return Notification.permission;
};

export const requestPushPermission = async (): Promise<NotificationPermission> => {
  return await Notification.requestPermission();
};

export const subscribeToPush = async (userId: string): Promise<boolean> => {
  try {
    if (!isPushSupported()) return false;
    if (!VAPID_PUBLIC_KEY) {
      console.warn('VITE_VAPID_PUBLIC_KEY nicht gesetzt');
      return false;
    }

    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY).buffer as ArrayBuffer,
    });

    const sub = subscription.toJSON();

    const { error } = await (supabase.from('push_subscriptions') as any).upsert({
      user_id: userId,
      endpoint: sub.endpoint,
      p256dh: sub.keys?.p256dh,
      auth: sub.keys?.auth,
      updated_at: new Date().toISOString(),
    }, { onConflict: 'user_id' });

    if (error) {
      console.error('Fehler beim Speichern der Push-Subscription:', error);
      return false;
    }

    console.log('✅ Push-Subscription gespeichert');
    return true;
  } catch (err) {
    console.error('Fehler beim Abonnieren von Push:', err);
    return false;
  }
};

export const unsubscribeFromPush = async (userId: string): Promise<boolean> => {
  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    if (subscription) {
      await subscription.unsubscribe();
    }
    await (supabase.from('push_subscriptions') as any).delete().eq('user_id', userId);
    return true;
  } catch (err) {
    console.error('Fehler beim Deabonnieren:', err);
    return false;
  }
};

export const getCurrentPushSubscription = async (): Promise<PushSubscription | null> => {
  try {
    const registration = await navigator.serviceWorker.ready;
    return await registration.pushManager.getSubscription();
  } catch {
    return null;
  }
};
